module.exports = __webpack_public_path__ + "img/case4.82d5d891.jpg";